module.exports =  {
    common:{
        csApp:'VitaHealth',
        laiKangApp:'LaiFeiHealth',
        deleteAccountTip1: '1. Delete the account through the app or on this website.',
        deleteAccountTip2: '2. User data will not be deleted, and users need to call customer service and verify the data before deleting the account data.',
        account:'Account',
        password:'Password',
        deleteAccount:'Delete',
        accountValid:'Please confirm if the account input is correct',
        passwordValid:'Please confirm if the password input is correct',
        accountAndPasswordValid:'Please confirm if the password or the account input is correct',
        deleteAccountSuccess:'delete success',
        deleteAccountFail:'delete fail',
        date:'date',
        time:'time',
        hour:"h",
        min:"m",
        second:"s",
        day:"day",
        week:"week",
        month:"month",
        year:"year",
        dayUnit:"",
        weekUnit:"week",
        monthUnitLast:"",
        monthUnit:"-",
        yearUnit:"-",
        detail:"detail",
        percent:"percent",
        percentUnit:"%",
        maxValue:'max',
        minValue:'min',
        highest:"highest",
        minimum:"minimum",
        normal:"normal",
        abnormal:"abnormal",
        normalPercent:"normal percentage",
        abnormalPercent:"abnormal percentage",
        numUnit:" ",
        to:"~",
        formatDateYMD:"YYYY-MM-DD",
        formatDateMD:"MM-DD",
        formatDateYM:"YYYY-MM",
        formatDateM:"MM",
        formatDateYMDHM:"YYYY-MM-D HH:mm",
        formatDateYMDHMS:"YYYY-MM-D HH:mm:ss",
        formatDateMDHMS:"MM-DD HH:mm:ss",
        tip:"tip",
        confirm:"confirm",
        cancel:"cancel",
        noData:"NoData",
        allDataLoadComplete:"All Data load Complete",
        waiting:"waiting",
        contentLoading:"Content loading",
        noContainData:"No Contain Data",
        noNetwork:"No Network",
        nowLoadingMoreData:"now loading more",
        monday: 'monday',
        tuesday: 'tuesday',
        wednesday: 'wednesday',
        thursday: 'thursday',
        friday: 'friday',
        saturday: 'saturday',
        sunday: 'sunday',
        showAll:'showAll',
        packUp:'packUp',
        showAllMore:'show more',
        packUpMore:'pack up',
        target:'target',
        dontReachStandard:'dontReachStandard',
        reachStandard:'reachStandard',
        totalDayNum:'Total Day Number',
        referenceValue:'reference Value',
        month1:'Jan',
        month2:'Feb',
        month3:'Mar',
        month4:'Apr',
        month5:'May',
        month6:'Jun',
        month7:'Jul',
        month8:'Aug',
        month9:'Sept',
        month10:'Oct',
        month11:'Nov',
        month12:'Dec',
        month1_long:'January',
        month2_long:'February',
        month3_long:'March',
        month4_long:'April',
        month5_long:'May',
        month6_long:'June',
        month7_long:'July',
        month8_long:'August',
        month9_long:'September',
        month10_long:'October',
        month11_long:'November',
        month12_long:'December',
        peleaseSelect:'please select',
        average:'average',
        numMinUnit:'/m',
    },
    sport:{
        sport:'Sport',
        sportType1: 'Outdoor Running',
        sportType2: 'Indoor Running',
        sportType3: 'Outdoor Walking',
        sportType4: 'Indoor Walking',
        sportType5: 'Outdoor cycling',
        sportType6: 'Indoor Cycling',
        sportType7: 'Swimming in the pool',
        sportType8: 'Development water area',
        sportType9: 'Climbing',
        sportType10: 'Hiking',
        sportType11: 'Off road running',
        sportType12: 'Golf Practice',
        sportsType13: 'Skiing',
        sportType14: 'Snowboarding',
        sportType15: 'Cross country skiing',
        sportType16: 'Ironman Triathlon',
        sportType17: 'Elliptical machine',
        sportType18: 'Rowing',
        sportType19: 'Jumping rope',
        sportType20: 'Badminton',
        sportType21: 'Table Tennis',
        sportsType22: 'Tennis',
        sportsType23: 'Basketball',
        sportType24: 'Football',
        sportType25: 'Baseball',
        sportType26: 'Volleyball',
        sportType27: 'Cricket',
        sportType28: 'Rugby',
        sportType29: 'Hockey',
        sportType30: 'Dance',
        sportType31: 'Dynamic Bike',
        sportType32: 'Yoga',
        sportType33: 'Sit ups',
        sportType34: 'Gymnastics',
        sportType35: 'Open close jump',
        consume:'consume',
        Pacing:'Pacing',
        Kilocalorie:'kcal',
        kilometre:'km',
        sportStatistics:'sportStatistics',
        distanceAndUnit:'distance（km）',
	distance:'distance',
        consumeAvg:'consume（kcal）',
        pacingAvg:'pacingAvg（/km）',
        cadenceAvg:'cadenceAvg（step/m）',
        timeNum:'time num',
        totalStepNum:'total step num',

        step:'Step',
        stepReport:'Step Report',
        stepUnit:'',
        stepAvg:'stepAvg',
        
        stepconsume:'Equivalent to consumption',
        stepStatistics:'stepStatistics',
        eggNum:' egg',
       
        stepDistance:'It is equivalent to leaving',
        stepDistanceNum:'Standard playground',
    },
    sleep:{  
        sleep:'Sleep',
        sportReport:'Sleep Report',
        sportHrSet:'Sleep Max Heart Rate',
        sleepTime:'sleepTime',
        deepSleep:'deepSleep',
        lightSleep:'lightSleep',
        eyeMovement:'eyeMovement',
        eyeMovementFast:'eyeMovementFast',
        sober:'sober',

        deepSleepAvg:'deepSleepAvg',
        lightSleepAvg:'lightSleepAvg',
        eyeMovementFastAvg:'eyeMovementFastAvg',

        sleepStatistics:'sleepStatistics',
        sleepNight:'sleepNight',
        sleepNightAvg:'sleepNightAvg',
        deepSleepRate:'deepSleepRate',
        deepSleepRateAvg:'deepSleepRateAvg',
        lightSleepRate:'lightSleepRate',
        lightSleepRateAvg:'lightSleepRateAvg',
        eyeMovementFastRate:'eyeMovementFastRate',
        eyeMovementFastRateAvg:'eyeMovementFastRateAvg',
        soberNumber:'soberNumber',
        soberNumberAvg:'soberNumberAvg',

        sleepBeginTimeAvg:'sleepBeginTimeAvg',
        sleepEndTimeAvg:'sleepEndTimeAvg',
        
    },
    measure:{
        bloodOxygenTitle:"bloodOxygen Report",
        bloodOxygen:"bloodOxygen",
        bloodOxygenPercent:"Proportion of blood oxygen status",
        bloodOxygenSaturation:" Blood oxygen saturation",
        bloodOxygenSaturationTip1:" Exercise is the best way to promote blood circulation and improve oxygen level. If you have some Respiratory disease",
        bloodOxygenSaturationTip2:"you should choose slow exercise to gradually increase blood oxygen saturation.",
        fingertip:"fingertip ",
        wrist:"wrist ",
        fingertipBloodOxygenList:"fingertip BloodOxygen List",
        wristBloodOxygenList:"wrist BloodOxygen List",
        bloodOxygenList:"bloodOxygen List",
        
        bloodPressure:'Blood pressure',
        bloodPressureDetail:'Blood pressure Detail',
        bloodPressureSys:'Systolic blood pressure',
        bloodPressureDia:'Diastolic blood pressure',
        mmHg:'Millimeter mercury column',
        measurementStatistics:'Measurement Statistics',
        measurementsTotalNumber:'Total number of measurements',
        measurementsNumber:'Number of measurements',
        bloodPressureMeasureTip1:'Monitor once in the morning (6:00~8:00 am for those undergoing treatment), once in the afternoon (17:00~19:00), and once in the evening (20:00~24:00 before bedtime).',
        bloodPressureMeasureTip2:'Before measurement, sit still and rest for 5 minutes. Each blood pressure measurement needs to be taken twice, with an interval of 1 minute between the two measurements;', 
        bloodPressureGoToMeasure:"Measure Now",
        measurementsReachStandardDayNum:'Measurement of days of compliance',
        bloodPressureStatus:'Blood pressure status',
        bloodPressureNormalNum:'Number of normal blood pressure times',
        bloodPressureNormalHighNum:'Number of times normal high blood pressure occurs',
        bloodPressureHighLevelOneNum:'Number of measurements for level 1 hypertension',
        bloodPressureHighLevelTwoNum:'Number of measurements for level 2 hypertension',
        bloodPressureStatistics:'Blood pressure statistics',
        bloodPressureAverage:'Average blood pressure',
        bloodPressureLoadValue:'Blood pressure load value',
        bloodPressureAvgSys:'avg sys',
        bloodPressureAvgDia:'avg dia',
        bloodPressureDaySys:'Daytime systolic blood pressure',
        bloodPressureDayDia:'Daytime diastolic blood pressure',
        bloodPressureNightSys:'Nighttime systolic blood pressure',
        bloodPressureNightDia:'Nighttime diastolic blood pressure',
        bloodPressureNightDropRate:'Night blood pressure drop rate',
        bloodPressureMeanArterialPressureAll:'Mean (arterial) pressure [MAP]',
        bloodPressureMeanArterialPressure:'Mean arterial pressure',
        bloodPressureCoefficientVariation:'Blood pressure coefficient of variation (CV)',
        measureTime:'measureTime',
        measureBeginTime:'measureBeginTime',
        measureEndTime:'measureEndTime',
        bloodPressureIndicators:'bloodPressureIndicators',
        keepHealthAwayNibpTip:'EN减少盐的摄入量；平衡膳食；避免有害使用酒精；经常运动；以及避免使用烟草。',
        bloodPressureNormal:'bloodPressureNormal',
        bloodPressureNormalHigh:'bloodPressureNormalHigh',
        bloodPressureHighLevelOne:'bloodPressureHighLevelOne',
        bloodPressureHighLevelTwo:'bloodPressureHighLevelTwo',
        bloodPressureProtectAdvice:'bloodPressureProtectAdvice',
        bloodPressureMeasureAdvice:'bloodPressureMeasureAdvice',
        day_avager:'day avg',  
        bloodPressureReport:'Blood Pressure Report',
        bloodPressureReportExplain:'Blood Pressure Report explain',
        bloodPressureReachDetail:'Blood Pressure Reach Detail ',
        explainDoctor:'explainDoctor',
        evaluate:'evaluate',
        reportProductSuccessTip:'reportProductSuccessTip',
        messageTip:'messageTip',
        reportProductIng:'reportProductIng,',
        diagnosisApply:'diagnosisApply',
        reportProductNeedTime:'EN解析报告需要1-2个小时',
        reprotDayReachStandard:'EN日达标规则：当日6:00~8:00；17:00~19:00；20:00~ 24:00达到目标测量次数（每个时间段两次）。',
        reprotWeekReachStandard:'EN周达标规则：历史七日，每日测量达标三次则周达标。',
        
        reprotReachStandardAdvice1:'EN请您在从今天开始接下来三天',
        reprotReachStandardAdvice2:'EN的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice3:'EN请您在今天和明天的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice4:'EN请您在今天的17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice5:'EN请您在今天的20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice6:'EN请您在今天的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice7:'EN请您在从明天开始接下来三天',
        reprotReachStandardAdvice8:'EN请您在从明天开始接下来两天',
        reprotReachStandardAdvice9:'EN请您在明天的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reportductIng:'EN生成中',
        readed:'readed',
        unread:'unread',

        suanHuaGuideTip1:'EN如何进行血压的学习和测量',
        suanHuaGuideTip2:'EN心壁血压功能学习和测量中的注意事项',
        suanHuaGuideTip3:'EN如何进行血压的学习',
        suanHuaGuideTip4:'EN快速了解血压的学习，开启精准血压测量',
        suanHuaGuideTip5:'EN手表血压功能学习和测量中的注意事项',
        suanHuaGuideTip6:'EN如何通过APP换表盘',
        suanHuaGuideTip7:'EN快速了解表盘，开启多种表盘，每天一换',
        
        heartRate:'Heart Rate',
        heartRateTitle:'Heart Rate Report',
        heartRateAvg:'heartRateAvg',
        fingertipheartRateList:"fingertip heartRate List",
        wristheartRateList:"wrist heartRate List",
        heartRateList:"heartRate List",

        pressurePressureIndex:'PressureIndex',
        pressureTired:'Tired',
        pressureSpirePressure:'SpirePressure',
        pressureTolerance:'Tolerance',
        pressureTitle:'Pressure Report',
        good: 'Good',
        notBad: 'Not bad',
        Moderate: 'Moderate',
        poor: 'Poor',
        easy: 'Easy',
        tired: 'Tired',
        fatigue: 'Fatigue',
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        veryHigh: 'Very high',
        lightHigh:'light High',
        lightLow:'light Low',
        fast:'fast',
        lightFast:'light fast',
        lightSlow:'light slow',
        temperature:'Temperature',
        temperatureReport:'Temperature Report',
        temperatureIndicators:'Temperature Indicators',

        measureDetailTip1Title:'Preparation before measurement',
        measureDetailTip10:'* The blood pressure measurement in the consulting room should be done in an appropriate space, at a suitable temperature (≈ 72 ° F/22 ℃), and in a quiet and noise free environment. Many factors related to the subject can cause deviations in blood pressure measurements, such as indoor temperature, exercise, drinking or smoking, arm position, muscle tension, bladder filling, speech, and environmental noise. The subjects speech is a common factor, so during pressure measurement, the subject should not speak, and medical staff should not speak to the subject.',
        measureDetailTip11:'1.Instruct the patient to relax and sit in a chair, with their feet flat on the ground and their back against the back of the chair, with their thighs not overlapping. Before the first measurement, sit still for more than 5 minutes and do not talk or move.',
        measureDetailTip12:'2.Avoid exercising, smoking, or drinking coffee for at least 30 minutes before starting the measurement.',
        measureDetailTip13:'3.Ensure that the patient empties the bladder.',
        measureDetailTip14:'4.During the process of measuring blood pressure, neither the patient nor medical staff should speak.',
        measureDetailTip15:'5.Remove the clothes covering the cuff area, fully expose the upper arm, and do not roll up the sleeves, as this may cause a tourniquet effect.',
        measureDetailTip2Title:'Choose the appropriate equipment and adopt the correct measurement method',
        measureDetailTip21:'1.Choose a mercury column sphygmomanometer that meets measurement standards, or an upper arm electronic sphygmomanometer that has been validated (ESH, BHS, and AAMI) to ensure regular calibration of the sphygmomanometer.',
        measureDetailTip22:'2.The measured person should take a seat, preferably in a back chair; Expose the right upper arm, place the elbow at the same level as the heart, and place the subjects arm naturally on the table without clenching, as muscle movements can affect blood pressure levels.',
        measureDetailTip23:'3.The blood pressure gauge should be placed at the heart level. The middle of the cuff is placed on the patients upper arm, level with the right atrium, equivalent to the midpoint of the sternum.',
        measureDetailTip24:'4.Binding the cuff: The measurer must first touch the brachial artery at the patients elbow fossa and place the center of the long axis of the cuff airbag (usually marked on the cuff by the manufacturer) on top of the arterial pulsation of the exposed upper arm. The lower end of the cuff should be 2 to 3 centimeters above the elbow socket, leaving room for the stethoscope head to be placed at the same level as the heart (nipple level). The cuff should be elastic enough to accommodate 1-2 fingers.',
        measureDetailTip25:'5.Use appropriately sized airbag cuffs, such as 75% to 100% of the airbag wrapping around the upper arm. Obese individuals or those with large arm circumference should use large-sized airbag cuffs, while children should use small-sized airbag cuffs.',
        measureDetailTip26:'6.Use a mercury blood pressure meter to place the probe of the stethoscope at the pulsation of the brachial artery in the cubital fossa, not inside the cuff.',
        measureDetailTip3Title:'Specification for auscultation (mercury sphygmomanometer) measurement',
        measureDetailTip31:'1.When using a mercury sphygmomanometer for measurement, the observers line of sight should be level with the dial of the sphygmomanometer, and the inflation should be uniform. The pressure inside the airbag should reach the point where the brachial artery pulsation disappears and then increase by 30mmHg, and then slowly deflate at a constant rate (2-6mm Hg/S). When the heart rate is slow, the rate of deflation is also slower. After obtaining the diastolic blood pressure reading, quickly deflate to zero.',
        measureDetailTip32:'2.During the deflation process, carefully listen to the Coriolis sound and observe the vertical height of the convex surface of the mercury column in the I and V phases of the Coriolis sound. The systolic blood pressure reading is taken from the first phase of the Coriolis sound (the first sound), and the diastolic blood pressure reading is taken from the fifth phase of the Coriolis sound (the vanishing sound)',
        measureDetailTip33:'3.All readings should be based on the top of the mercury convex surface; The reading should take an even number (0, 2, 4, 6, 8). The electronic sphygmomanometer is based on displaying blood pressure data.',
        measureDetailTip34:'4.Measure at least 2 times and repeat the measurement at intervals of 1 minute. If the readings of systolic or diastolic blood pressure in the adjacent 2 times are less than 5mm Hg, take the average of the 2 times. If they are greater than 5mm Hg, take the third time and take the average of the 3 times. When reading blood pressure values, the last digit can only be an even number.',
        measureDetailTip4Title:'Frequency of blood pressure measurement',
        measureDetailTip401:'《2019 Chinese Family Blood Pressure Monitoring Guidelines》',
        measureDetailTip402:'When monitoring blood pressure at home, it is recommended to',
        measureDetailTip403:'Daily morning and evening',
        measureDetailTip404:'Measure blood pressure',
        measureDetailTip41:'1.Each measurement should be taken 2-3 times after resting in the sitting position for 5 minutes, with an interval of 1 minute',
        measureDetailTip42:'2.Newly diagnosed patients, those who have received early treatment or whose blood pressure has not yet reached the standard, should be continuously measured for 5-7 days before seeking medical attention; Blood pressure',
        measureDetailTip43:'3.When the control is good, measure at least 1 day per week.',
        measureDetailTip44:'4.Morning blood pressure measurements should be taken within 1 hour after waking up, before taking antihypertensive drugs, before breakfast, and before vigorous activities. Evening blood pressure measurements are taken after dinner and before going to bed',
        measureDetailTip45:'5.Whether in the morning or at night, it is important to empty the bladder before measuring blood pressure.',
        measureDetailTip46:'6.To ensure the quality of family blood pressure monitoring, the time of getting up, going to bed, having three meals, and taking medication should be recorded during the blood pressure monitoring period.',
        measureDetailTip5Title:'Physiological changes in blood pressure',
        measureDetailTip51:'1.Age: As age increases, both diastolic and systolic blood pressure gradually increase.',
        measureDetailTip52:'2.Gender: Female, before menopause, lower than male; After menopause, blood pressure increases with little difference.',
        measureDetailTip53:'3.Environment: Cold environment, slightly elevated blood pressure; In a high-temperature environment, blood pressure can slightly decrease.',
        measureDetailTip54:'4.Day and night and sleep: Usually, it reaches its peak at 6-10 am, decreases from 14:00-15:00 pm, rises again to its peak at 16:00-18:00, and then slowly decreases until the lowest trough at 2-3 am. When resting and sleeping poorly, blood pressure slightly increases.',
        measureDetailTip50:'* Blood pressure fluctuations are also related to factors such as measured posture, indoor temperature, smoking, alcohol consumption, arm position, movement, speech, and external environmental noise, and should be measured in a calm state according to regulations.',
        measureDetailTip6Title:'Diagnostic criteria for hypertension using different measurement methods',
        measureDetailTip7Title:'Several major misconceptions affecting blood pressure readings',
        measureDetailTip71:'1.Bladder filling: i.e. holding urine, may cause blood pressure readings to be approximately 10-15 mmHg higher. Before measuring blood pressure, the bladder should be emptied.',
        measureDetailTip72:'2.Improper sitting posture: including laziness, lack of support in the back or lower limbs, etc., may cause blood pressure readings to be approximately 6-10 mmHg higher. When measuring blood pressure, it is necessary to lean back against the chair and place your feet flat on the floor or footstool.',
        measureDetailTip73:'3.Arm suspension: May cause blood pressure readings to be approximately 10 mmHg higher. When measuring blood pressure, the arm should be placed flat on the table, with the measuring cuff level with the heart.',
        measureDetailTip74:'4.Sleeves placed on clothing may cause blood pressure readings to be approximately 5-50 mmHg higher. When measuring blood pressure, if the thickness of the diaphragm is less than 1 mm (such as a thin shirt), it is best to expose the arm.',
        measureDetailTip75:'5.The cuff is too small or too tight: it may cause the blood pressure reading to be approximately 2-10 mmHg higher. You should choose the appropriate size cuff.',
        measureDetailTip76:'6.Cross legged: May cause blood pressure readings to be approximately 2-8 mmHg higher. When measuring blood pressure, do not cross your legs and support your feet flat.',
        measureDetailTip77:'7.Speech: When measuring blood pressure, the subject may ask questions, answer questions, or make phone calls, which may cause the blood pressure reading to be approximately 10 mmHg higher. When measuring blood pressure, be careful not to speak and keep quiet.',
        measureDetailTip8Title:'Differences in blood pressure measurement between different postures',
        measureDetailTip81:'Blood pressure can be measured in sitting, lying, standing, and other positions, but the diagnosis and treatment of hypertension has always been based on sitting blood pressure. Therefore, in various guidelines',
        measureDetailTip82:'It is recommended that daily blood pressure measurements be taken in a sitting position for hypertensive patients. For patients who are inconvenient to sit in for blood pressure measurement, they can lie down for blood pressure measurement.',
        measureDetailTip83:'As long as the measurement process is standardized, it doesnt matter which posture measurement is more accurate, it reflects the human blood pressure under different postures or postures.',
        measureDetailTip84:'The blood pressure value of the sitting position method is reduced by about 3mm Hg compared to the lying position method; The measurement in the standing position decreases by about 5mm Hg compared to the sitting position and by 8mm Hg compared to the lying position.',
        measureDetailTip85:'That is, lying position>sitting position>standing position',
        measureDetailTip86:'The above differences are all statistically significant',
    }
}